import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getReturns(params) {
        return Axios.get(`${baseURL}billing/returns`, {
            params
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    getReturn(returnId, encoded = false) {
        return Axios.get(`${baseURL}billing/return/${returnId}`, {
            params: {
                encoded
            }
        }).then(response => response.data.response);
    },
    generatePrintPdf(returnId) {
        return Axios.get(
            `${baseURL}billing/return/pdf-request/${returnId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    getCurrentAdministratorReturnApproval() {
        return Axios.get(`${baseURL}billing/return/check-approval`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    postConfirm(returnId) {
        return Axios.get(
            `${baseURL}billing/return/post-confirm/${returnId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    prePost(params) {
        return Axios.post(`${baseURL}billing/return/pre-post`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    postReturn(params) {
        return Axios.post(`${baseURL}billing/return/post`, params).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    removeReturn(returnId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}billing/return/${returnId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    emailReturn(params) {
        return Axios.post(`${baseURL}billing/return/send-email`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    newReturn(params) {
        return Axios.post(`${baseURL}billing/return`, params).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    postReturnStripeInteract(params) {
        return Axios.post(
            `${baseURL}billing/stripe/return/transaction`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    updateReturn(returnId, params) {
        return Axios.put(`${baseURL}billing/return/${returnId}`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                } else {
                    return null;
                }
            }
        );
    },
    getInvoiceItems(params) {
        return Axios.post(
            `${baseURL}billing/return/filter-invoices`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    getInvoiceItem(params) {
        return Axios.post(
            `${baseURL}billing/returnItem/find-item-quantity`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    createReturnItem(params) {
        return Axios.post(`${baseURL}billing/returnItem`, params).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    editReturnItem(itemId, params) {
        return Axios.put(`${baseURL}billing/returnItem/${itemId}`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    }
};
